import "./Hero.css";

export default function Hero({ onOpenModal }) {
  return (
    <section className="hero" id="top">
      <div className="hero-bg" />
      <div className="hero-grid" />

      <div className="hero-content">
        <div className="hero-eyebrow">
          On-device · Hindi + English · No internet needed
        </div>
        <h1 className="hero-h1">
          Your PDFs.
          <em>Finally understood.</em>
        </h1>
        <p className="hero-sub">
          TAGpdf extracts text, detects language, and tags your documents{" "}
          <strong>entirely on your device</strong> — with no server, no account,
          and no waiting.
        </p>
        <div className="hero-actions">
          <button className="btn-primary" onClick={onOpenModal}>
            Get Early Access
          </button>
          <a
          className="prd-hunt-btn"
            href="https://www.producthunt.com/products/tagpdf-your-documents-indexed/reviews/new?utm_source=badge-product_review&utm_medium=badge&utm_source=badge-tagpdf&#0045;your&#0045;documents&#0045;indexed"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="https://api.producthunt.com/widgets/embed-image/v1/product_review.svg?product_id=1203717&theme=dark"
              alt="TAGpdf&#0032;—&#0032;Your&#0032;Documents&#0044;&#0032;Indexed&#0046; - Organize&#0032;and&#0032;search&#0032;PDFs&#0032;instantly&#0032;with&#0032;AI | Product Hunt"
              width="200"
              height="50"
            />
          </a>
        </div>
      </div>

      {/* Floating card */}
      <div className="hero-card">
        <div className="card-file">
          <span>invoice_feb.pdf</span>
          <span className="done">✓ done</span>
        </div>
        <div className="card-text">
          Invoice #INV-2026-042
          <br />
          Amount: <span className="hi">₹24,500</span>
          <br />
          <span className="hi">कंपनी: अभय एंटर.</span>
          <br />
          Date: 15 Feb 2026
        </div>
        <div className="card-tags">
          <span className="card-tag">invoice</span>
          <span className="card-tag">finance</span>
          <span className="card-tag">hindi</span>
          <span className="card-tag">feb-2026</span>
        </div>
        <div className="card-status">
          <div className="status-dot" />
          Processed on-device
        </div>
      </div>
    </section>
  );
}
